import * as actions from 'src/constants/actionTypes'
import { createReducer } from 'src/utils/reducer'
import { dispatchErrorToast } from 'src/store/modules/utils/toast'

export const initialSessionsState = {
    byId: {},
    uids: [],
}

const sessions = createReducer(initialSessionsState, {})

export const startSession = (dispatch, runbookId) => ({
    type: actions.API,
    method: 'post',
    data: {
        runbook_id: runbookId,
    },
    payload: {
        url: `/api/runbooks/util/runbook/${runbookId}/session/`,
        start: () => ({
            type: actions.START_RUNBOOK_SESSION,
            runbookId,
        }),
        success: (payload) => ({
            type: actions.START_RUNBOOK_SESSION_SUCCESS,
            runbookId,
            data: payload.data,
        }),
        error: (error) => {
            dispatchErrorToast(dispatch, 'Failed to start runbook session.')
            return {
                type: actions.START_RUNBOOK_SESSION_FAILED,
                error,
            }
        },
    },
})

export const endSession = (dispatch, runbookId, sessionId, discard) => ({
    type: actions.API,
    method: 'put',
    data: {
        runbook_id: runbookId,
        discard_session: discard,
    },
    payload: {
        url: `/api/runbooks/util/runbook/${runbookId}/session/${sessionId}/`,
        start: () => ({
            type: actions.END_RUNBOOK_SESSION,
            runbookId,
        }),
        success: (payload) => ({
            type: actions.END_RUNBOOK_SESSION_SUCCESS,
            runbookId,
            data: payload.data,
        }),
        error: (error) => {
            dispatchErrorToast(dispatch, 'Failed to end runbook session.')
            return {
                type: actions.END_RUNBOOK_SESSION_FAILED,
                error,
            }
        },
    },
})

export default sessions
